import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  useMediaQuery,
} from "@mui/material";
import { formattedAmountWithoutAed } from "../../../../utils/CommonFunction";
import { isEmpty } from "lodash";
import BudgetItemModal from "./components/BudgetItemModal";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";
import MobileView from "./MobileView";


export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  textTransform: "capitalize",
}));

export default function Budget({ details, isMobile, styles }) {
  const [selectedBudget, setSelectedBudget] = useState(null);

  // Use isMobile prop directly, no fallback needed
  const isMobileDevice = isMobile;

  // Get styles with mobile parameter
  const componentStyles = styles || styles(isMobileDevice);

  const handleClick = (item) => {
    console.log("item", item);
    setSelectedBudget(item);
  };

  if (isMobileDevice) {
    return (
      <>
        <MobileView
          details={details}
          selectedBudget={selectedBudget}
          setSelectedBudget={setSelectedBudget}
          handleClick={handleClick}
        />
        {selectedBudget && (
          <BudgetItemModal
            selectedBudget={selectedBudget}
            setSelectedBudget={setSelectedBudget}
          />
        )}
      </>
    );
  }

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          overflow: "visible",
          boxShadow: "none",
          marginTop: "2vh",
        }}
      >
        <Table
          sx={{
            "& thead": {
              "& th": {
                color: "#949DAA",
                fontWeight: "500",
              },
            },
            "& tbody": {
              "& tr:hover": {
                backgroundColor: "#f7f7f7",
              },
              "& tr": {
                borderBottom: "none",
              },
            },
          }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Item</StyledTableCell>
              <StyledTableCell>Units</StyledTableCell>

              <StyledTableCell>
                <strong
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  Unit Cost ({renderCurrencyIcon('small')})
                </strong>
              </StyledTableCell>

              <StyledTableCell>Manpower Rate</StyledTableCell>
              <StyledTableCell>Days</StyledTableCell>

              <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                <strong
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  Total Cost ({renderCurrencyIcon('small')})
                </strong>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {details?.milestone?.map((milestone, milestoneIdx) => (
              <React.Fragment key={`milestone-${milestoneIdx}`}>
                <TableRow>
                  <StyledTableCell
                    colSpan={9}
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#fff",
                      fontSize: "14px",
                    }}
                  >
                    {milestone?.milestone_name}
                  </StyledTableCell>
                </TableRow>
                {milestone?.budget?.map((item, budgetIdx) => (
                  <TableRow key={`budget-${budgetIdx}`}>
                    <StyledTableCell
                      style={{
                        flex: 1.5,
                        cursor: "pointer",
                      }}
                      onClick={() => handleClick(item)}
                    >
                      <Box display="flex" alignItems="center">
                        <Box
                          component="img"
                          src={
                            !isEmpty(item?.buget_image)
                              ? item?.buget_image[0]?.image
                              : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                          }
                          alt="Project Icon"
                          sx={{
                            width: 45,
                            height: 45,
                            borderRadius: "8px",
                            border: "2px solid white",
                            boxShadow: "0px 4px 2.67px 0px #00000026",
                            marginRight: 1,
                          }}
                        />
                        {item?.name}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      {item?.qty !== null ? item.qty : "-"}
                    </StyledTableCell>

                    <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                      {item?.material_unit_price
                        ? formattedAmountWithoutAed(
                          item?.material_unit_price
                        )
                        : "-"}
                    </StyledTableCell>
                    <StyledTableCell>
                      {item?.manpower_rate || "-"}
                    </StyledTableCell>

                    <StyledTableCell >
                      {item?.days || "-"}
                    </StyledTableCell>

                    <StyledTableCell sx={{ flex: 0.5, textAlign: "right" }}>
                      {formattedAmountWithoutAed(item?.total_item)}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedBudget && (
        <BudgetItemModal
          selectedBudget={selectedBudget}
          setSelectedBudget={setSelectedBudget}
        />
      )}
    </>
  );
}